module.exports = __webpack_public_path__ + "img/banner-1.09793fc5.jpg";